import { RoutePath } from "#src/utils/route";
import { WorkersRoutePath } from "..";

/** Base path for worker run routes. Resolves to /app/workers/runs. */
export const WorkerRunsRoutePath = WorkersRoutePath.concat(
  new RoutePath({
    path: "/runs",
    title: "Runs",
    isPresentational: true,
  })
);
